<template>
  <div>
    <div
      v-if="availableProfiles.length"
      class="flex items-end mx-0 my-2 gap-1"
    >
      <a
        v-for="profile in availableProfiles"
        :key="profile.key"
        :href="`${profile.link}${socialProfiles[profile.key]}`"
        target="_blank"
        rel="noopener noreferrer nofollow"
        :class="['transition-colors duration-150', customClass, 'hover:bg-[#1f93ff] dark:hover:bg-slate-700 rounded p-1']"
        v-tooltip="profile.key"
      >
        <fluent-icon
          :icon="`brand-${profile.key}`"
          size="16"
          :viewBox="profile.key === 'twitter' ? '0 0 16 16' : '0 0 24 24'"
          class="dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200"
          style="color: #40518a"
        />
      </a>
    </div>

    <!-- Fallback message when no profiles are available -->
    <div v-else class="text-slate-500 italic" style="font-size: 12px;">
      No Social Profiles
    </div>
  </div>
</template>

<script>
export default {
  props: {
    socialProfiles: {
      type: Object,
      default: () => ({}),
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      socialMediaLinks: [
        { key: 'facebook', icon: 'facebook', link: 'https://facebook.com/' },
        { key: 'twitter', icon: 'twitter', link: 'https://twitter.com/' },
        { key: 'linkedin', icon: 'linkedin', link: 'https://linkedin.com/' },
        { key: 'github', icon: 'github', link: 'https://github.com/' },
        { key: 'instagram', icon: 'instagram', link: 'https://instagram.com/' },
      ],
    };
  },
  computed: {
    availableProfiles() {
      return this.socialMediaLinks.filter(
        mediaLink => !!this.socialProfiles[mediaLink.key]
      );
    },
  },
};
</script>
